import { useEffect } from "react"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { useApolloClient } from "@apollo/client"
import qs from "query-string"
import { isLoggedInVar } from "cache"
import { TEMP_SESSION_KEY } from "shared/constants"

const Consume = () => {
  const history = useHistory()
  const location = useLocation()
  const { url, id = "" } = useParams()
  const client = useApolloClient()

  useEffect(() => {
    const searchParams = qs.parse(location.search)
    const tmpTag = searchParams[TEMP_SESSION_KEY]
    const { email } = searchParams
    const redirectUrl = searchParams.r || "/"

    if (tmpTag) {
      sessionStorage.setItem(TEMP_SESSION_KEY, tmpTag)

      if (email) {
        sessionStorage.setItem("temp_session_email", email)
      }

      isLoggedInVar(true)

      client.clearStore().then(() => {
        history.replace(redirectUrl)
      })
    }
    // Original behavior for /consume/:url/:id
    history.replace(`/${url}/${id}`, {
      hideNav: true
    })
  }, [history, url, id, location.search, client])

  return null
}

export default Consume
